import { Title } from '@angular/platform-browser';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IExamen } from '../../../../../app/database/models/IExamen.model';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Examen } from '../../../../shared/forms/templates/exams-config/Examen.config';
import { Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { AsideService } from '../../../../shared/components/aside/aside.service';
import { MessageAlertService } from '../../../../shared/views/_messagesService/_messageAlertServices';
import { BackgroundSyncService } from '../../../../../app/helpers/backgroundSync.service';
import { ExamsConfigService } from '../../../../shared/forms/templates/exams-config/exams-config.service';
import { DatabaseService } from '../../../../../app/database/database.service';
import moment from 'moment';
import { environment } from '../../../../../environments/environment';
import { GroupDTemplateService } from '../../../../shared/forms/templates/group-d-template/group-d-template.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';
import { IEspecialidades } from '../../../../../app/database/models/IEspecialidades.model';

interface Table {
	cadera: any;
	modoVista: 'ver' | 'edicion';
}

enum Status {
	'NOR' = 'NOR',
	'ANO' = 'ANO'
}

const defaultArticulacion: ByArticulacion = {
	abduccion: Status.NOR,
	aduccion: Status.NOR,
	extencion: Status.NOR,
	flexion: Status.NOR,
	irradiacion: Status.NOR,
	rotacionExterna: Status.NOR,
	rotacionInterna: Status.NOR,
	alteracionMasaMuscular: Status.NOR,
};

interface ByArticulacion {
	abduccion: Status;
	aduccion: Status;
	extencion: Status;
	flexion: Status;
	irradiacion: Status;
	rotacionExterna: Status;
	rotacionInterna: Status;
	alteracionMasaMuscular: Status;
}

interface Articulacion {
	der: ByArticulacion;
	izq: ByArticulacion;
}


interface ExamenInput extends IExamen {
	cadera: Articulacion;
	rodilla: Articulacion;
	tobillo: Articulacion;
	codo: Articulacion;
	hombro: Articulacion;
	manoDedos: Articulacion;
	munieca: Articulacion;
	modoVista: 'ver' | 'edit';
	edad: any;
}

@Component({
	selector: 'app-group-d-template',
	templateUrl: './group-d-template.component.html',
	styleUrls: ['./group-d-template.component.scss'],
	styles: [
		`
      :host ::ng-deep .p-cell-editing {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
      }
    `,
	],
})
export class GroupDTemplateComponent implements OnInit, OnDestroy {
  storedUser = sessionStorage.getItem('currentUser');
	public currentUser = this.storedUser ? JSON.parse(this.storedUser) : null;
	@Input() examen: ExamenInput | any;
	submitted = false;
	public examForm: FormGroup;
	seniority = 0;
	unidadTiempo = '';
	maxDate = new Date();
	maxDateIngreso = new Date();
	minDate: any;
	asideObservable: Subscription;
	displayAgentes = false;
	invalidField = false;
	baseUrl =
		'https://lasegundatesting.conexia.com.ar:8444/lasegunda-ml-api/exams/carga/';
	configForm: Examen;
	tiposDictamen: any[] = [];
	salesMMSS: any[] = [];
	salesMMII: any[] = [];
	statuses = [
		{ label: 'Normal', value: Status.NOR },
		{ label: 'Anormal', value: Status.ANO },
	];
	tiempoTareaValues = [
		{ label: 'Esporádico', value: 'A' },
		{ label: 'Continuo: > 2 Hs. Y < 4 Hs.', value: 'B' },
		{ label: 'Continuo: > 4 Hs.', value: 'C' }
	];
	manipulacionCargaValues = [
		{ label: '< de 1 Kg.', value: 'A' },
		{ label: 'Entre 1 Kg. y 3 Kgs.', value: 'B' },
		{ label: '> de 3 Kgs.', value: 'C' }
	];
	cicloTrabajoValues = [
		{ label: 'Corto: hasta 30 Seg.', value: 'A' },
		{ label: 'Moderado: 30 Seg. a 1 o 2 minutos', value: 'B' },
		{ label: 'Largo: > 2 Minutos', value: 'C' }
	];
	artilulaciones: string[] = [];
	tiposCaracterizacionSemiologicaMMSS: any[] = [];
	tiposCaracterizacionSemiologica: any[] = [];
	attachedFiles: any = {
		data: [],
		invalid: false,
		isEmpty: true,
		attachedFilesValidQuantity: 0
	};
	enviandose = false;
	especialidades: IEspecialidades[];
	isOnline = true;
	displayModalFirma = false;
	medicoFirmaB64;
	medicoFirmaSigString;

	constructor(private titleService: Title,
		private fb: FormBuilder,
		private router: Router,
		private groupDTemplateService: GroupDTemplateService,
		private confirmationService: ConfirmationService,
		private asideService: AsideService,
		private messageAlertServices: MessageAlertService,
		private backgroundSyncService: BackgroundSyncService,
		private examConfigService: ExamsConfigService,
		private databaseService: DatabaseService,
		private connectionService: ConnectionService
	) {
	}

	get f(): any {
		return this.examForm.controls;
	}

	ngOnDestroy(): void {
		this.titleService.setTitle('Provincia ART ML Offline');
		this.asideService.setInsideExamen(false);
	}

	ngOnInit(): void {
		this.titleService.setTitle('Provincia ART ML Offline');

		this.connectionService.monitor().subscribe((connected: ConnectionState) => {
			this.isOnline = connected.hasNetworkConnection;
		})
		const onLine = localStorage.getItem('isStillOnline');
		this.isOnline = onLine ? JSON.parse(onLine) : null;
		this.getTiposCaracterizacionSemiologica();
		this.cargarFormulario();
		this.calcularAntiguedad();
		this.getTiposDictamen();
		this.getEspecialidades();
		this.minDate = new Date(moment(this?.examen?.fechaAsignacion).format());
		this.asideObservable = this.asideService.openModalSubject$.subscribe(
			(data) => {
				this.goBack(data);
			}
		);
		this.asideService.setInsideExamen(true);

    console.log(this.examForm.value);
	}

	cargarFormulario(): void {
		let codigoTipoExamen = (this.examen.tipoEstudio.codigo !== undefined)
		? this.examen.tipoEstudio.tipoEstudioCod
		: this.examen.tipoEstudio;
		this.configForm = this.examConfigService.getConfig(codigoTipoExamen);
		this.configForm.name = this.examen.provinciaNombreEstudio;
		this.salesMMSS = this.configForm.configTableSegmentoMMSS;
		this.salesMMII = this.configForm.configTableSegmentoMMII;
		this.setSalesFromExamen();
		this.examForm = this.configForm.examForm;
		this.examen.trabajador.apellidoNombre ? this.examForm.controls.apellidoNombre.setValue(this.examen.trabajador.apellidoNombre) : null;
    	this.examen.trabajador.fechaNacimiento ? this.examForm.controls.fechaNacimiento.setValue(new Date(moment(this.examen.trabajador.fechaNacimiento).format())) : null;
		this.calculateAge();
		this.examen.puestoTrabajador ?
		this.examForm.controls.puestoTrabajador.setValue(this.examen.puestoTrabajador) : null;
		this.examen.antiguedadPuestoTrabajador ?
		this.examForm.controls.antiguedadPuestoTrabajador.setValue(this.standarizeDate(this.examen.antiguedadPuestoTrabajador)) : null;
		this.examen.fechaIngresoEmpresa ?
		this.examForm.controls.fechaIngresoEmpresa.setValue(new Date(moment(this.examen.fechaIngresoEmpresa).format())) : null;
		this.restrictDateIngresoEmpresa();
		this.medicoFirmaB64 = this.examen.medicoFirmaB64;
    	this.medicoFirmaSigString = this.examen.medicoFirmaSigString;
		if (this.examen?.modoVista === "edit" || this.examen.modoVista === 'ver' || this.examen?.cargadoOffline) {
			this.setValuesOnFormOnVerOrEditMode();
		} else {
			this.examen.antLaboral = this.examForm.controls.antLaboral.value;
			this.clickCheckBox('antLaboralNo', {checked: true});
			this.examen.flexionSostenidaCol = this.examForm.controls.flexionSostenidaCol.value;
			this.clickCheckBox('flexionSostenidaColNo', {checked: true});
			this.examen.sinParticularidades = this.examForm.controls.sinParticularidades.value;
			this.clickCheckBox('sinParticularidades', {checked: true});
		}
	}

	standarizeDate(date: any) {
		let splitedDate = date.replace(/\//g, '-');
		const dateParts = splitedDate.split('-');
		if (date.includes('/')) {
			return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
		} else {
			return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
		}
	}

	private getDescripcionDomicilio(): string {
		return (this.examen.trabajador.calle)
			? `${this.examen.trabajador.calle} ${this.examen.trabajador.numeroCalle ? this.examen.trabajador.numeroCalle : ''}`
			: '';
	}

	/**
	 * setea la informaicion que viene del examen en la variable Sales que se recorre
	 * en el template
	 */
	setSalesFromExamen(): void {
		this.salesMMSS = this.salesMMSS.map(sale => {
			return {
				...sale,
				der: this.examen[sale.articulacion]?.der || { ...defaultArticulacion },
				izq: this.examen[sale.articulacion]?.izq || { ...defaultArticulacion },
			};
		});
		this.salesMMII = this.salesMMII.map(sale => {
			return {
				...sale,
				der: this.examen[sale.articulacion]?.der || { ...defaultArticulacion },
				izq: this.examen[sale.articulacion]?.izq || { ...defaultArticulacion },
			};
		});
	}

	cleanSalesMMSSFromExamen(): void {
		this.salesMMSS = this.configForm.configTableSegmentoMMSS;
		this.salesMMSS = this.salesMMSS.map(sale => {
			return {
				...sale,
				der: { ...defaultArticulacion },
				izq: { ...defaultArticulacion },
			};
		});
	}

	cleanSalesMMIIFromExamen(): void {
		this.salesMMII = this.configForm.configTableSegmentoMMII;
		this.salesMMII = this.salesMMII.map(sale => {
			return {
				...sale,
				der: { ...defaultArticulacion },
				izq: { ...defaultArticulacion },
			};
		});
	}

	/**
	 * retorna el label del estado de la articulacion
	 * @param value
	 * @return label
	 */
	getLabelStatus(value: Status): string {
		if (value) {
			return this.statuses.find(statu => statu.value === value)?.label || '';
		}
		return '';
	}

	/**
	 * Método que se encarga de obtener los tipos de dictamen
	 */
	async getTiposDictamen(): Promise<void> {
		const dataFromOffline = await this.databaseService.getAllTiposDictamenFromOfflineDB();
		this.tiposDictamen = dataFromOffline.filter(
			(x) => x.codigo === 'A' || x.codigo === 'I' || x.codigo === 'N'
		);
	}

	async getEspecialidades(): Promise<void> {
		const especialidadesListFromOffline = await this.databaseService.getAllEspecialidadesFromOfflineDB();
		this.especialidades = especialidadesListFromOffline;
	}

	async getTiposCaracterizacionSemiologica(): Promise<void> {
		let dataFromOffline = await this.databaseService.getAllTiposCaracterizacionSemiologicaFromOfflineDB();
		this.tiposCaracterizacionSemiologica = dataFromOffline;
		this.tiposCaracterizacionSemiologicaMMSS = dataFromOffline;
	}


	/**
	 * Método que se encarga de calcular la antiguedad del trabajador (en meses o años)
	 */
	calcularAntiguedad(): void {
		if (this.examen.fechaAltaEmpleado) {
			this.seniority = moment().diff(
				moment(this.examen.fechaAltaEmpleado),
				'years'
			);
			if (this.seniority > 1) {
				this.unidadTiempo = 'años';
			} else if (this.seniority < 1) {
				this.seniority = moment().diff(
					moment(this.examen.fechaAltaEmpleado),
					'months'
				);
				if (this.seniority > 1) {
					this.unidadTiempo = 'meses';
				} else {
					this.unidadTiempo = 'mes';
				}
			} else {
				this.unidadTiempo = 'año';
			}
		}
	}

	/**
	 * Método que se encarga
	 * @param ruta
	 */
	goBack(ruta?): void {
		if (this.examForm.dirty) {
			this.confirm(ruta);
		} else {
			this.returnToExams(ruta);
		}
	}

	/**
	 * Método que se encarga de abrir el modal y redirigir a la pagina de la ruta que recibe
	 * @param ruta ruta para redirigir
	 */
	confirm(ruta?): void {
		this.confirmationService.confirm({
			header: `¿Está seguro de que desea cancelar la carga del examen?`,
			message: `Si cancela el examen ahora perderá toda la información cargada hasta el momento`,
			key: 'goBackFormEC',
			accept: () => {
				this.returnToExams(ruta);
			},
		});
	}

	returnToExams(ruta?: string): void {
		this.router.navigate([ruta ? ruta : 'examenes']);
	}

	buildUrlApi(method: string): string {
		return `${environment.apiUrl}` + method;
	}

	buildRequest(): any {
		let examFormData = { ...this.examForm.getRawValue() };
		examFormData.userId = this.currentUser.userId;
		examFormData.username = this.currentUser.username;
		examFormData.modelId = this.currentUser.modelId;
		examFormData.tipoEstudio = this.configForm.code;
		examFormData.examenNumero = this.examen.id;
		examFormData.fechaRealizacion = moment(examFormData.fechaRealizacion).format(
		'yyyy-MM-DD'
		);
		examFormData.fechaIngresoEmpresa = moment(examFormData.fechaIngresoEmpresa).format(
		'yyyy-MM-DD'
		);
		examFormData.antiguedadPuestoTrabajador = moment(examFormData.antiguedadPuestoTrabajador).format('yyyy-MM-DD');
		this.examen?.modoVista === "edit" ? examFormData.esEdicion = !!(this.examen?.modoVista === "edit" && this.isOnline) : null;
		examFormData.adjuntos = this.attachedFiles.data;
		examFormData.medicoFirmaB64 = this.medicoFirmaB64;
		examFormData.medicoFirmaSigString = this.medicoFirmaSigString;
		examFormData.tipoCaracterizacionSemiologicaMMSS = examFormData.tipoCaracterizacionSemiologicaMMSS === '' ? 'GR0' : examFormData.tipoCaracterizacionSemiologicaMMSS;
		examFormData.tipoCaracterizacionSemiologicaMMII = examFormData.tipoCaracterizacionSemiologicaMMII === '' ? 'GR0' : examFormData.tipoCaracterizacionSemiologicaMMII;
		Object.assign(examFormData, this.processData(this.salesMMSS));
		Object.assign(examFormData, this.processData(this.salesMMII));
		examFormData.antLaboral = this.examForm.controls.antLaboralSi.value;
		examFormData.tipoMovHombro = this.examForm.controls.tipoMovHombroSi.value;
		examFormData.tipoMovMuneca = this.examForm.controls.tipoMovMunecaSi.value;
		examFormData.tipoMovNervio = this.examForm.controls.tipoMovNervioSi.value;
		examFormData.tipoMovCubitales = this.examForm.controls.tipoMovCubitalesSi.value;
		examFormData.tipoOtro = this.examForm.controls.tipoOtroSi.value;
		examFormData.tipoCuello = this.examForm.controls.tipoCuelloSi.value;
		examFormData.tipoColumna = this.examForm.controls.tipoColumnaSi.value;
		examFormData.tipoRotAntebrazo = this.examForm.controls.tipoRotAntebrazoSi.value;
		examFormData.tipoFlexCodo = this.examForm.controls.tipoFlexCodoSi.value;
		examFormData.tipoFlexDedo = this.examForm.controls.tipoFlexDedoSi.value;
		examFormData.flexionSostenidaCol = this.examForm.controls.flexionSostenidaColSi.value;

		examFormData = this.evaluateChangeTrabajador(examFormData);

		return examFormData;
	}

	private evaluateChangeTrabajador(object) {
		if (this.examen.seModificoTrabajador
			|| this.examen.trabajador.fechaNacimiento != moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			|| this.examen.trabajador.apellidoNombre != this.examForm.controls.apellidoNombre.value) {

			object.trabajador = {
				apellidoNombre: this.examForm.controls.apellidoNombre.value,
				fechaNacimiento: moment(this.examForm.controls.fechaNacimiento.value).format('yyyy-MM-DD')
			};
			this.examen.seModificoTrabajador = true;
		}
		return object;
	}

	capitalize(word: string): string {
		if (!word) {
			return word;
		}
		return word[0].toUpperCase() + word.substr(1).toLowerCase();
	}

	async onSubmit(): Promise<void> {
		this.submitted = true;
		if (this.examForm.invalid || this.invalidField || this.attachedFiles.invalid || this.medicoFirmaB64 == null) {
			this.navigateInvalidField('ng-invalid');
			return;
		}
		this.enviandose = true;
		if (this.isOnline) {
			this.saveToOnline();
		} else {
			this.saveToOffline();
		}
	}

	processData(tableData: any[]): any {
		const obj = {};
		const side = {
			izq: 'izq',
			der: 'der',
		};
		tableData.map((x) => {
			obj[x.articulacion] = {};
			const keys = Object.keys(x.der);
			const der = {};
			const izq = {};
			keys.map((k) => {
				der[k] = x.der[k].toUpperCase().substring(0, 3);
				izq[k] = x.izq[k].toUpperCase().substring(0, 3);
			});
			obj[x.articulacion][side.der] = der;
			obj[x.articulacion][side.izq] = izq;
		});
		return obj;
	}

	/**
	 * función que recibe el trigger desde el componente attach-upload-file
	 * con el objeto actualizado de la lista de archivos y errores
	 * @param  {object} event
	 * @example:
	 *  {
	 *    errors: {
	 *      isSizeValid: false
	 *      isTypeValid: false,
	 *    },
	 *    data: [
	 *       {
	 *        archivoBase64: todounstringpegado,
	 *        nombreOriginal: "example.png",
	 *        tipo: "png",
	 *        size: 121354,
	 *        esAlta:false,
	 *        esBaja:false
	 *    ],
	 *    invalid: false,
	 *    isEmpty: true,
	 *    attachedFilesValidQuantity: 0
	 *  }
	 */
	getAttachedFiles(event: any): any {
		const { errors } = event;

		this.attachedFiles = event;
		if (errors.isSizeValid && errors.isTypeValid) {
			// asigno la data al objeto para enviar
			return false;
		}
	}

	// tiposCaracterizacionSemiologica
	private saveToOnline(): void {

		this.groupDTemplateService.loadExam(this.buildRequest(), this.configForm.baseUrl).subscribe((response) => {
			this.databaseService.deleteItemFromTable(this.examen.id,
				`examenes${(this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion')}`);
			this.databaseService.deleteItemFromTable(this.examen.id,
				`examenes${(this.examen.categoriaExamen === 'periodicos'
					? 'PeriodicosFiltrados'
					: 'ReevaluacionFiltrados')}`);
			this.messageAlertServices.setMessage(0, {
				severity: 'success',
				summary: '',
				detail: response.message,
				key: 'examen',
			});
			setTimeout(() => {
				this.returnToExams();
			}, 500);
			this.enviandose = false;
		},
			(error) => {
				this.formatResponseAndOpenError(error);
			}
		);
	}

	formatResponseAndOpenError(error) {
		let message = error.error.message + ' ';
		message = message + error.error.errors.map((x) => {
			return x;
		}).join(' ');
		this.openErrorAlert(message, 'examen');
	}

	private openErrorAlert(message: string, key: string): void {
		this.messageAlertServices.setMessage(0, {
			severity: 'error',
			summary: '',
			detail: message,
			key: key,
		});
		setTimeout(() => {
			const header = document.querySelector('#templateContainer') as any;
			window.scroll(0, header.offsetTop - 150);
		}, 100);
		this.enviandose = false;
	}

	private saveToOffline(): void {
		const dataToSend = this.buildRequest();
		dataToSend.fechaCarga = moment().format('yyyy-MM-DD');
		dataToSend.cargadoOffline = true;
		const details = (this.examen?.modoVista === "edit") ? 'Los cambios en el examen fueron guardados correctamente' : 'El examen se guardó correctamente en Por enviar';

		this.databaseService
			.setExameneOnExamenesPorEnviarTable(
				this.examen,
				dataToSend,
				false,
				this.examen.categoriaExamen === 'periodicos'
					? 'Periodicos'
					: 'Reevaluacion',
				this.buildUrlApi(this.configForm.baseUrl)
			)
			.then((response) => {
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'Periodicos'
						: 'Reevaluacion')}`);
				this.databaseService.deleteItemFromTable(this.examen.id,
					`examenes${(this.examen.categoriaExamen === 'periodicos'
						? 'PeriodicosFiltrados'
						: 'ReevaluacionFiltrados')}`);
				this.backgroundSyncService.registerEvent('save-examen');
				this.messageAlertServices.setMessage(0, {
					severity: 'success',
					summary: '',
					detail: details,
					key: 'examen',
				});
				setTimeout(() => {
					this.returnToExams();
				}, 500);
			})
			.catch((e) => {
				this.messageAlertServices.setMessage(0, {
					severity: 'error',
					summary: '',
					detail:
						'Ha ocurrido un error. Por favor reinitent más tarde y disculpe las molestias ocasionadas',
					key: 'examen',
				});
			});
	}

	private calculateAge(): void {
		let edad: number | null = null;
		if (this.examForm.controls.fechaNacimiento.value) {
			edad = moment().diff(
			  moment(this.examForm.controls.fechaNacimiento.value),
			  'years'
			);
		}
		this.examen.trabajador.edad = edad;
	}

	restrictDateIngresoEmpresa(): void {
		if(this.examForm.controls.antiguedadPuestoTrabajador.value != null && this.examForm.controls.antiguedadPuestoTrabajador.value != "") {
		  this.maxDateIngreso = this.examForm.controls.antiguedadPuestoTrabajador.value;
		} else {
		  this.maxDateIngreso = this.maxDate;
		}
	}

	private navigateInvalidField(classFocus: string): void {
		const invalidFields = [].slice.call(
			document.getElementsByClassName(classFocus)
		);
		const field = invalidFields[1];
		field.scrollIntoViewIfNeeded();
		field.focus();
	}

	showModalFirma() {
		this.displayModalFirma = true;
	}

	closeModalFirma() {
		this.displayModalFirma = false;
	}

	recibirDatosFirma(datos: { firmaB64: string, firmaSigString: string }) {
        this.medicoFirmaB64 = datos.firmaB64;
        this.medicoFirmaSigString = datos.firmaSigString;
    }

	clickRadioButton(valor) {
		switch (valor) {
			case 'dolorAgudoMmss':
				this.examForm.controls['dolorInsidiosoMmss'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'dolorInsidiosoMmss':
				this.examForm.controls['dolorAgudoMmss'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoContinuoMmss':
				this.examForm.controls['cursoBrotesMmss'].setValue(false);
				this.examForm.controls['cursoCiclicoMmss'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoBrotesMmss':
				this.examForm.controls['cursoContinuoMmss'].setValue(false);
				this.examForm.controls['cursoCiclicoMmss'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoCiclicoMmss':
				this.examForm.controls['cursoContinuoMmss'].setValue(false);
				this.examForm.controls['cursoBrotesMmss'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'dolorAgudoMmii':
				this.examForm.controls['dolorInsidiosoMmii'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'dolorInsidiosoMmii':
				this.examForm.controls['dolorAgudoMmii'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoContinuoMmii':
				this.examForm.controls['cursoBrotesMmii'].setValue(false);
				this.examForm.controls['cursoCiclicoMmii'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoBrotesMmii':
				this.examForm.controls['cursoContinuoMmii'].setValue(false);
				this.examForm.controls['cursoCiclicoMmii'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'cursoCiclicoMmii':
				this.examForm.controls['cursoContinuoMmii'].setValue(false);
				this.examForm.controls['cursoBrotesMmii'].setValue(false);
				this.validateCheckboxItems();
				break;
			case 'tipoCaracterizacionSemiologicaMMSS':
				if (this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value === 'GR0') {
					this.examForm.controls['dolorAgudoMmss'].setValue(false);
					this.examForm.controls['dolorInsidiosoMmss'].setValue(false);
					this.examForm.controls['cursoContinuoMmss'].setValue(false);
					this.examForm.controls['cursoBrotesMmss'].setValue(false);
					this.examForm.controls['cursoCiclicoMmss'].setValue(false);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoCaracterizacionSemiologicaMMII':
				if (this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value === 'GR0') {
					this.examForm.controls['dolorAgudoMmii'].setValue(false);
					this.examForm.controls['dolorInsidiosoMmii'].setValue(false);
					this.examForm.controls['cursoContinuoMmii'].setValue(false);
					this.examForm.controls['cursoBrotesMmii'].setValue(false);
					this.examForm.controls['cursoCiclicoMmii'].setValue(false);
				}
				this.validateCheckboxItems();
				break;
		}
	  }

	clickCheckBox(valor, event) {
		switch (valor) {
			case 'antLaboralSi':
				this.examForm.controls.antLaboralNo.setValue(false);
				this.examForm.controls.antLaboral.setValue(true);
				this.clickCheckboxHabilitar(event.checked, true, 'desAntLaboral');
				break;
			case 'antLaboralNo':
				this.examForm.controls.antLaboralSi.setValue(false);
				this.examForm.controls.antLaboral.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'desAntLaboral');
				break;
			case 'tipoMovHombroSi':
				this.examForm.controls.tipoMovHombroNo.setValue(false);
				this.examForm.controls.tipoMovHombro.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoMovHombroSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovHombroNo':
				this.examForm.controls.tipoMovHombroSi.setValue(false);
				this.examForm.controls.tipoMovHombro.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoMovHombroSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovMunecaSi':
				this.examForm.controls.tipoMovMunecaNo.setValue(false);
				this.examForm.controls.tipoMovMuneca.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoMovMunecaSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovMunecaNo':
				this.examForm.controls.tipoMovMunecaSi.setValue(false);
				this.examForm.controls.tipoMovMuneca.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoMovMunecaSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovNervioSi':
				this.examForm.controls.tipoMovNervioNo.setValue(false);
				this.examForm.controls.tipoMovNervio.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoMovNervioSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovNervioNo':
				this.examForm.controls.tipoMovNervioSi.setValue(false);
				this.examForm.controls.tipoMovNervio.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoMovNervioSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovCubitalesSi':
				this.examForm.controls.tipoMovCubitalesNo.setValue(false);
				this.examForm.controls.tipoMovCubitales.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoMovCubitalesSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoMovCubitalesNo':
				this.examForm.controls.tipoMovCubitalesSi.setValue(false);
				this.examForm.controls.tipoMovCubitales.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoMovCubitalesSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoOtroSi':
				this.examForm.controls.tipoOtroNo.setValue(false);
				this.examForm.controls.tipoOtro.setValue(true);
				this.clickCheckboxHabilitar(event.checked, true, 'descTipoOtro');
				if (!event.checked) {
					this.examForm.controls.tipoOtroSi.setValue(null);
					this.clickCheckboxHabilitar(event.checked, false, 'descTipoOtro');
				}
				break;
			case 'tipoOtroNo':
				this.examForm.controls.tipoOtroSi.setValue(false);
				this.examForm.controls.tipoOtro.setValue(false);
				this.clickCheckboxHabilitar(event.checked, false, 'descTipoOtro');
				if (!event.checked) {
					this.examForm.controls.tipoOtroSi.setValue(null);
				}
				break;
			case 'tipoCuelloSi':
				this.examForm.controls.tipoCuelloNo.setValue(false);
				this.examForm.controls.tipoCuello.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoCuelloSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoCuelloNo':
				this.examForm.controls.tipoCuelloSi.setValue(false);
				this.examForm.controls.tipoCuello.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoCuelloSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoColumnaSi':
				this.examForm.controls.tipoColumnaNo.setValue(false);
				this.examForm.controls.tipoColumna.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoColumnaSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoColumnaNo':
				this.examForm.controls.tipoColumnaSi.setValue(false);
				this.examForm.controls.tipoColumna.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoColumnaSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoRotAntebrazoSi':
				this.examForm.controls.tipoRotAntebrazoNo.setValue(false);
				this.examForm.controls.tipoRotAntebrazo.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoRotAntebrazoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoRotAntebrazoNo':
				this.examForm.controls.tipoRotAntebrazoSi.setValue(false);
				this.examForm.controls.tipoRotAntebrazo.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoRotAntebrazoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoFlexCodoSi':
				this.examForm.controls.tipoFlexCodoNo.setValue(false);
				this.examForm.controls.tipoFlexCodo.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoFlexCodoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoFlexCodoNo':
				this.examForm.controls.tipoFlexCodoSi.setValue(false);
				this.examForm.controls.tipoFlexCodo.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoFlexCodoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoFlexDedoSi':
				this.examForm.controls.tipoFlexDedoNo.setValue(false);
				this.examForm.controls.tipoFlexDedo.setValue(true);
				if (!event.checked) {
					this.examForm.controls.tipoFlexDedoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'tipoFlexDedoNo':
				this.examForm.controls.tipoFlexDedoSi.setValue(false);
				this.examForm.controls.tipoFlexDedo.setValue(false);
				if (!event.checked) {
					this.examForm.controls.tipoFlexDedoSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'flexionSostenidaColSi':
				this.examForm.controls.flexionSostenidaColNo.setValue(false);
				this.examForm.controls.flexionSostenidaCol.setValue(true);
				if (!event.checked) {
					this.examForm.controls.flexionSostenidaColSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'flexionSostenidaColNo':
				this.examForm.controls.flexionSostenidaColSi.setValue(false);
				this.examForm.controls.flexionSostenidaCol.setValue(false);
				if (!event.checked) {
					this.examForm.controls.flexionSostenidaColSi.setValue(null);
				}
				this.validateCheckboxItems();
				break;
			case 'sinParticularidades':
				this.examForm.controls.miembrosSuperiores.setValue(false);
				this.examForm.controls.miembrosInferiores.setValue(false);
        this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.disable();
        this.examForm.controls.tipoCaracterizacionSemiologicaMMII.disable();
				this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.setValue('GR0');
				this.examForm.controls.tipoCaracterizacionSemiologicaMMII.setValue('GR0');
				this.examen.tipoCaracterizacionSemiologicaMMSS = 'GR0';
				this.examen.tipoCaracterizacionSemiologicaMMII = 'GR0';
				this.examForm.controls.dolorAgudoMmss.setValue(false);
				this.examForm.controls.dolorInsidiosoMmss.setValue(false);
				this.examForm.controls.cursoContinuoMmss.setValue(false);
				this.examForm.controls.cursoBrotesMmss.setValue(false);
				this.examForm.controls.cursoCiclicoMmss.setValue(false);
				this.examForm.controls.dolorAgudoMmii.setValue(false);
				this.examForm.controls.dolorInsidiosoMmii.setValue(false);
				this.examForm.controls.cursoContinuoMmii.setValue(false);
				this.examForm.controls.cursoBrotesMmii.setValue(false);
				this.examForm.controls.cursoCiclicoMmii.setValue(false);
				this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.setValidators(null);
				this.examForm.controls.tipoCaracterizacionSemiologicaMMII.setValidators(null);
				this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.updateValueAndValidity();
				this.examForm.controls.tipoCaracterizacionSemiologicaMMII.updateValueAndValidity();
				this.cleanSalesMMSSFromExamen();
				this.cleanSalesMMIIFromExamen();
				this.validateCheckboxItems();
				break;
			case 'miembrosSuperiores':
				if (event.checked) {
					this.examForm.controls.sinParticularidades.setValue(false);
					this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.setValidators(Validators.required);
					this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.updateValueAndValidity();
					this.validateCheckboxItems();
				} else {
					this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.setValue('GR0');
					this.examen.tipoCaracterizacionSemiologicaMMSS = 'GR0';
					this.examForm.controls.dolorAgudoMmss.setValue(false);
					this.examForm.controls.dolorInsidiosoMmss.setValue(false);
					this.examForm.controls.cursoContinuoMmss.setValue(false);
					this.examForm.controls.cursoBrotesMmss.setValue(false);
					this.examForm.controls.cursoCiclicoMmss.setValue(false);
					this.cleanSalesMMSSFromExamen();
				}
				break;
			case 'miembrosInferiores':
				if (event.checked) {
					this.examForm.controls.sinParticularidades.setValue(false);
					this.examForm.controls.tipoCaracterizacionSemiologicaMMII.setValidators(Validators.required);
					this.examForm.controls.tipoCaracterizacionSemiologicaMMII.updateValueAndValidity();
					this.validateCheckboxItems();
				} else {
					this.examForm.controls.tipoCaracterizacionSemiologicaMMII.setValue('GR0');
					this.examen.tipoCaracterizacionSemiologicaMMII = 'GR0';
					this.examForm.controls.dolorAgudoMmii.setValue(false);
					this.examForm.controls.dolorInsidiosoMmii.setValue(false);
					this.examForm.controls.cursoContinuoMmii.setValue(false);
					this.examForm.controls.cursoBrotesMmii.setValue(false);
					this.examForm.controls.cursoCiclicoMmii.setValue(false);
					this.cleanSalesMMIIFromExamen();
				}
				break;
		}
	}

	clickCheckboxHabilitar(checked, value, field): void {
		this.validateCheckboxItems();
		if (!value || !checked) {
			this.examForm.controls[field].disable();
			this.examForm.controls[field].setValue('');
			this.examForm.controls[field].setValidators(null);
		} else {
			this.examForm.controls[field].enable();
			this.examForm.controls[field].setValidators([
				Validators.required,
				Validators.maxLength(1000),
			]);
		}
		this.examForm.controls[field].updateValueAndValidity();
	}

	validateCheckboxItems(): void {
		if ((!this.examForm.controls.antLaboralNo.value && !this.examForm.controls.antLaboralSi.value)
			|| (!this.examForm.controls.flexionSostenidaColNo.value && !this.examForm.controls.flexionSostenidaColSi.value)
			|| (!this.examForm.controls.miembrosSuperiores.value && !this.examForm.controls.miembrosInferiores.value && !this.examForm.controls.sinParticularidades.value)
			|| (this.examForm.controls.miembrosSuperiores.value && (this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value === ''))
			|| (!this.isValidDoloresMMSS())
			|| (!this.isValidCursoMMSS())
			|| (this.examForm.controls.miembrosInferiores.value && (this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value === ''))
			|| (!this.isValidDoloresMMII())
			|| (!this.isValidCursoMMII())) {
			this.invalidField = true;
		} else {
			this.invalidField = false;
		}
	}

	getEnableDoloresMMSS(): boolean {
		return (this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== 'GR0'
				&& this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== null);
	}

	isValidDoloresMMSS(): boolean {
		if (this.examForm.controls.sinParticularidades.value) return true;
		if (this.examForm.controls.miembrosSuperiores.value) {
			if (this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== 'GR0'
			&& this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== null) {
				return (this.examForm.controls.dolorAgudoMmss.value || this.examForm.controls.dolorInsidiosoMmss.value)
			}
		}
		return true;
	}

	isValidCursoMMSS(): boolean {
		if (this.examForm.controls.sinParticularidades.value) return true;
		if (this.examForm.controls.miembrosSuperiores.value) {
			if (this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== 'GR0'
			&& this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.value !== null) {
				return (this.examForm.controls.cursoContinuoMmss.value || this.examForm.controls.cursoBrotesMmss.value || this.examForm.controls.cursoCiclicoMmss.value)
			}
		}
		return true;
	}

	getEnableDoloresMMII(): boolean {
		return (this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== 'GR0'
		&& this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== null);
	}

	isValidDoloresMMII(): boolean {
		if (this.examForm.controls.sinParticularidades.value) return true;
		if (this.examForm.controls.miembrosInferiores.value) {
			if (this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== 'GR0'
			&& this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== null) {
				return (this.examForm.controls.dolorAgudoMmii.value || this.examForm.controls.dolorInsidiosoMmii.value)
			}
		}
		return true;
	}

	isValidCursoMMII(): boolean {
		if (this.examForm.controls.sinParticularidades.value) return true;
		if (this.examForm.controls.miembrosInferiores.value) {
			if (this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== 'GR0'
			&& this.examForm.controls.tipoCaracterizacionSemiologicaMMII.value !== null) {
				return (this.examForm.controls.cursoContinuoMmii.value || this.examForm.controls.cursoBrotesMmii.value || this.examForm.controls.cursoCiclicoMmii.value)
			}
		}
		return true;
	}

	private setValuesOnFormOnVerOrEditMode(): void {
		this.examForm.controls.fechaRealizacion.setValue(this.examen.fechaRealizacion);
		this.examen.codigoDictamen = this.examen.tipoDictamen ? this.examen.tipoDictamen : this.examen.codigoDictamen;
		this.examForm.controls.codigoDictamen.setValue(this.examen.codigoDictamen);
		this.examForm.controls.medicoEspecialidad.setValue(this.examen.medicoEspecialidad);
		this.examForm.controls.medicoMatricula.setValue(this.examen.medicoMatricula);
		this.examForm.controls.medicoNombre.setValue(
      this.examen.medicoNombre ? this.examen.medicoNombre.replace(/[&\/\\#,+()$~%.'":*?<>{}]/g, '') : ''
    );
		this.examForm.controls.desTrabHab.setValue(this.examen.desTrabHab ? this.examen.desTrabHab : '');
		this.examForm.controls.desAntLaboral.setValue(this.examen.desAntLaboral ? this.examen.desAntLaboral : '');
		this.examen.antLaboral ? this.clickCheckboxHabilitar(true, true, 'desAntLaboral') : null;
		this.examForm.controls.tiempoHoras.setValue(this.examen.tiempoHoras ? this.examen.tiempoHoras : '');
		this.examForm.controls.tiempoSemanas.setValue(this.examen.tiempoSemanas ? this.examen.tiempoSemanas : '');
		this.examForm.controls.descTipoOtro.setValue(this.examen.descTipoOtro ? this.examen.descTipoOtro : '');
		this.examen.tipoOtro ? this.clickCheckboxHabilitar(true, true, 'descTipoOtro') : null;
		this.examForm.controls.cicloDescHerramientas.setValue(this.examen.cicloDescHerramientas ? this.examen.cicloDescHerramientas : '');
		this.examForm.controls.cicloTurnoTrab.setValue(this.examen.cicloTurnoTrab ? this.examen.cicloTurnoTrab : '');
		this.examForm.controls.cicloPausaTrab.setValue(this.examen.cicloPausaTrab ? this.examen.cicloPausaTrab : '');
		this.examForm.controls.obsMed.setValue(this.examen.obsMed ? this.examen.obsMed : '');
		this.examForm.controls.sinParticularidades.setValue(this.examen.tipoCaracterizacionSemiologicaMMSS === 'GR0' && this.examen.tipoCaracterizacionSemiologicaMMII === 'GR0');
		this.examen.sinParticularidades = this.examForm.controls.sinParticularidades.value;
		this.examForm.controls.miembrosSuperiores.setValue(this.examen.tipoCaracterizacionSemiologicaMMSS !== null && this.examen.tipoCaracterizacionSemiologicaMMSS !== 'GR0');
		this.examForm.controls.miembrosInferiores.setValue(this.examen.tipoCaracterizacionSemiologicaMMII !== null && this.examen.tipoCaracterizacionSemiologicaMMII !== 'GR0');
    if (this.examen.tipoCaracterizacionSemiologicaMMSS === 'GR0') this.examForm.controls.tipoCaracterizacionSemiologicaMMSS.disable();
    if (this.examen.tipoCaracterizacionSemiologicaMMII === 'GR0') this.examForm.controls.tipoCaracterizacionSemiologicaMMII.disable();
		this.invalidField = false;
	}

	deshabilitarApellidoNombreTrabajador() {
		return this.examen.trabajador.apellidoNombre.replace(/[^a-zA-Z]/g, '').toLowerCase() !== 'alta' && this.examen.trabajador.apellidoNombre.trim().length !== 0;
	}
}
